import * as z from "zod/v4";

export const getPickListCsv = {
  name: "getPickListCsv" as const,
  input: z.union([
    z.object({ fulfillmentGroupIds: z.array(z.string()) }),
    z.object({ batchId: z.string() }),
  ]),
  output: z.object({ url: z.string() }),
};
